import React, { useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import { http } from "../helper";
import { useTranslation } from "react-i18next";

const AddFreeproductspdf = () => {
  const { t } = useTranslation();
  const [inputFieldtitle, setInputFieldtitle] = useState([]);
  const [fileinput, setFileInput] = useState([]);
  const [bannerImage, setBannerImage] = useState(null); // for banner image file
  const [bannerImagePreview, setBannerImagePreview] = useState(null); // for banner image preview
  const [errormsg, setErrormsg] = useState({});
  const [errmessage, setErrMessage] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState([]);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFeatured, setIsFeatured] = useState(true); // For featured checkbox
  const [sortOrder, setSortOrder] = useState(1);
  const [status, setStatus] = useState("active");
  const [displayTitleInBanner, setDisplayTitleInBanner] = useState(false); // Display title in banner
  const [inputType, setInputType] = useState("pdf"); // 'pdf' or 'url'
  const [urlInput, setUrlInput] = useState(""); // URL input
  const [urlTarget, setUrlTarget] = useState(""); // URL target (self or new window)

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_newproducts")
  ) {
    window.location.href = "/unauthorized";
  }

  function cancelbtn(e) {
    e.preventDefault();
    window.location.href = "/newproducts";
    return false;
  }

  const formvalidation = () => {
    const errmessage = {};
    const errmsg = {};
    let isValid = true;
    if (inputFieldtitle == "") {
      errmessage.inputFieldtitleerr = t("field_required_txt");
      errmsg.inptitletxt = true;
      isValid = false;
    }
    if (!sortOrder || sortOrder < 1) {
      errmessage.sortOrdererr = t("sort_order_must_be_greater_than_zero_txt");
      errmsg.sortOrdertxt = true;
      isValid = false;
    }
    if (inputType === "pdf") {
      if (document.getElementById("pdf_file").files.length == 0) {
        errmessage.fileinputerr = t("field_required_txt");
        errmsg.fileinptxt = true;
        isValid = false;
      } else {
        if (!hasExtension("pdf_file", [".pdf"])) {
          errmessage.fileinputerr = t("only_pdf_allowed_txt");
          errmsg.fileinptxt = true;
          isValid = false;
        } else {
          errmsg.fileinptxt = false;
        }
      }
    } else if (inputType === "url") {
      if (!urlInput.trim()) {
        errmessage.urlinputerr = t("url_required_txt");
        errmsg.urlinputtxt = true;
        isValid = false;
      } else if (!/^(https?:\/\/)/.test(urlInput.trim())) {
        errmessage.urlinputerr = t("valid_url_required_txt");
        errmsg.urlinputtxt = true;
        isValid = false;
      } else {
        errmsg.urlinputtxt = false;
      }
      if (!urlTarget) {
        errmessage.UrlTargetErr = t("select_url_target_txt");
        errmsg.UrlTargetErr = true;
        isValid = false;
      }
    }
    if (isValid) {
      setErrMessage({});
      setErrormsg({});
      return true;
    } else {
      setErrMessage(errmessage);
      setErrormsg(errmsg);
      return false;
    }
  };

  const submitButton = (e) => {
    e.preventDefault();
    const isValid = formvalidation();
    if (isValid) {
      const fileData = inputType === "pdf" ? fileinput : urlInput;
      uploadFile(fileData, bannerImage);
    }
  };

  const eventhandlechange = (e) => {
    setInputFieldtitle(e.target.value);
    if (errmessage.inputFieldtitleerr) {
      setErrMessage((prevState) => ({ ...prevState, inputFieldtitleerr: "" }));
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (event.target.id === "pdf_file") {
      setFileInput(file);
      if (errmessage.fileinputerr) {
        setErrMessage((prevState) => ({ ...prevState, fileinputerr: "" }));
      }
    } else if (event.target.id === "banner_file") {
      setBannerImage(file);
      setBannerImagePreview(URL.createObjectURL(file)); // Preview the uploaded image
      if (errmessage.bannerImageErr) {
        setErrMessage((prevState) => ({ ...prevState, bannerImageErr: "" }));
      }
    }
  };

  const hasExtension = (inputID, exts) => {
    var fileName = document.getElementById(inputID).value;
    return new RegExp("(" + exts.join("|").replace(/\./g, "\\.") + ")$").test(
      fileName,
    );
  };

  const uploadFile = async (file, bannerFile) => {
    setIsLoading(true);
    try {
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      const formData = new FormData(); // Create a FormData object
      if (inputType === "pdf") {
        formData.append("pdf", file); // Append the PDF file
      } else if (inputType === "url") {
        formData.append("urlInput", file); // Append the URL
        formData.append("urlTarget", urlTarget); // Append URL target
      }
      formData.append("title", inputFieldtitle.trim());
      formData.append("displayTitleInBanner", displayTitleInBanner); // New field for display title in banner
      formData.append("featuredpdf", isFeatured); // New field for featured checkbox
      formData.append("sortOrder", sortOrder); // New field for sort order
      formData.append("status", status);
      formData.append("inputType", inputType); // Add input type
      // Append banner image only if it exists
      if (bannerFile) {
        formData.append("bannerImage", bannerFile); // Append the banner image
      }
      // Make a POST request to your Node.js server endpoint
      // Check PDF file size only when uploading a PDF
      let fileSize = 0;
      if (inputType === "pdf") {
        let fileEle = document.getElementById("pdf_file");
        fileSize = (fileEle.files[0].size / 1024 / 1024).toFixed(2);
      }
      // Check banner file size only if it exists
      let bannerFileSize = bannerFile
        ? (
            document.getElementById("banner_file").files[0].size /
            1024 /
            1024
          ).toFixed(2)
        : 0;
      if (fileSize > 8 || (bannerFile && bannerFileSize > 2)) {
        setIsLoading(false);
        setVisibleAlert(true);
        return false;
      }
      const response = await http.post(BaseUrl + "admin/addpdf", formData);
      if (response.data.success === true) {
        setIsLoading(false);
        setAlertPopup(true);
        setAlertMessage(t("new_products_added_successfully_txt"));
      }
    } catch (error) {
      // Handle error
      setIsLoading(false);
      setAlertPopup(true);
      setAlertMessage(
        error?.response?.data?.message ||
          error?.message ||
          t("something_went_wrong_txt"),
      );
      console.error("Error uploading file:", error);
    }
  };

  const popupClose = (event) => {
    setVisibleAlert(false);
  };

  return (
    <section className="dashboard-block">
      {alertPopup && (
        <div
          className="custom-alert-pop common_alert_popup"
          style={{ display: "block" }}
        >
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{alertMessage}</p>
                <div className="alert-buttons">
                  <a
                    onClick={(e) => cancelbtn(e)}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container">
            <h1 className="checkout-title">{t("add_new_products_txt")}</h1>
            <div className="right-table-outer-wrap">
              {isLoading ? (
                <div className="loading-buffer"></div>
              ) : (
                <form
                  method="post"
                  className="addform editform freeprod-form freeproduct-fieldset form-container-xs"
                  onSubmit={submitButton}
                >
                  <div className="input-field col-1">
                    <label>{t("title_txt")}</label>
                    <div className="flex align-center gap-10">
                      <input
                        type="text"
                        value={inputFieldtitle}
                        name="inputFieldtitle"
                        onChange={eventhandlechange}
                        className="form-control"
                        placeholder={t("title_txt")}
                      />
                    </div>
                    {errmessage.inputFieldtitleerr && (
                      <div className="error-msg">
                        {errmessage.inputFieldtitleerr}
                      </div>
                    )}
                  </div>
                  <div className="input-field col-1">
                    <div className="flex align-center gap-10">
                      <div className="check-box">
                        <input
                          type="checkbox"
                          id="displayTitle"
                          checked={displayTitleInBanner}
                          onChange={(e) =>
                            setDisplayTitleInBanner(e.target.checked)
                          }
                        />
                        <label htmlFor="displayTitle">{t("display_in_banner_txt")}</label>
                      </div>
                    </div>
                  </div>
                  <div className="input-field col-1">
                    <label>{t("select_content_type_txt")}</label>
                    <div className="edit-free-cat-chks">
                      <div className="check-box">
                        <input
                          type="radio"
                          id="typePdf"
                          name="contentType"
                          value="pdf"
                          checked={inputType === "pdf"}
                          onChange={(e) => setInputType(e.target.value)}
                        />
                        <label htmlFor="typePdf">{t("pdf_txt")}</label>
                      </div>
                      <div className="check-box">
                        <input
                          type="radio"
                          id="typeUrl"
                          name="contentType"
                          value="url"
                          checked={inputType === "url"}
                          onChange={(e) => setInputType(e.target.value)}
                        />
                        <label htmlFor="typeUrl">{t("url_txt")}</label>
                      </div>
                    </div>
                  </div>
                  {inputType === "pdf" && (
                    <div className="input-field col-1">
                      <label>{t("pdf_txt")}</label>
                      <span className="text-note">
                        {" "}
                        ({t("max_upload_file_size_txt")}: 8 MB)
                      </span>
                      <div className="flex align-center gap-10">
                        <input
                          className="col-2"
                          type="file"
                          id="pdf_file"
                          accept=".pdf"
                          onChange={handleFileUpload}
                        />
                        <span className="text-note">
                          {t("pdf_files_only_allowed_txt")}
                          <br />
                          <br />
                        </span>
                      </div>
                      {errmessage.fileinputerr && (
                        <div className="error-msg">
                          {errmessage.fileinputerr}
                        </div>
                      )}
                    </div>
                  )}
                  {inputType === "url" && (
                    <div className="input-field col-2">
                      <label>{t("url_txt")}</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t("url_placeholder_txt")}
                        value={urlInput}
                        onChange={(e) => {
                          setErrMessage((prevState) => ({
                            ...prevState,
                            urlinputtxt: false,
                            urlinputerr: "",
                          }));
                          setUrlInput(e.target.value);
                        }}
                      />
                      {errmessage.urlinputerr && (
                        <div className="error-msg">
                          {errmessage.urlinputerr}
                        </div>
                      )}
                    </div>
                  )}
                  {inputType === "url" && (
                    <div className="input-field col-2">
                      <label>{t("target_txt")}</label>
                      <select
                        className="urlwindow"
                        value={urlTarget}
                        onChange={(e) => {
                          setUrlTarget(e.target.value);
                          setErrMessage((prevState) => ({
                            ...prevState,
                            UrlTargetErr: "",
                          }));
                        }}
                      >
                        <option value="">{t("select_txt")}</option>
                        <option value="_self">{t("same_window_txt")}</option>
                        <option value="_blank">{t("new_window_txt")}</option>
                      </select>
                      {errmessage.UrlTargetErr && (
                        <div className="error-msg">
                          {errmessage.UrlTargetErr}
                        </div>
                      )}
                    </div>
                  )}
                  <div className="input-field col-1">
                    <label>{t("banner_image_txt")}</label>
                    <span className="text-note">
                      {" "}
                      ({t("max_upload_file_size_txt")}: 2 MB)
                    </span>
                    <div className="flex align-center gap-10">
                      <input
                        className="col-2"
                        type="file"
                        id="banner_file"
                        accept=".jpg,.jpeg,.png"
                        onChange={handleFileUpload}
                      />
                      <span className="text-note">
                        {t("image_files_only_allowed_txt")}
                        <br />
                        <br />
                      </span>
                    </div>
                    {errormsg.bannerImageTxt && (
                      <div className="color-red">
                        {errmessage.bannerImageErr}
                      </div>
                    )}
                  </div>
                  {bannerImagePreview && (
                    <div className="input-field col-1">
                      <img src={bannerImagePreview} alt="Banner Preview" />
                    </div>
                  )}
                  {/* Featured Checkbox */}
                  <div className="input-field col-1">
                    <label>{t("display_on_main_page_txt")}</label>
                    <div className="check-box">
                      <input
                        type="checkbox"
                        id="setImg"
                        className="check-box"
                        checked={isFeatured}
                        onChange={(e) => setIsFeatured(e.target.checked)}
                      />
                      <label htmlFor="setImg">{t("yes_txt")}</label>
                    </div>
                  </div>
                  {/* Sorting Input */}
                  <div className="input-field col-1">
                    <label className="full-width">{t("sort_order_txt")}</label>
                    <input
                      type="number"
                      value={sortOrder}
                      onChange={(e) => {
                        setSortOrder(e.target.value);
                        if (errmessage.sortOrdererr) {
                          setErrMessage((prevState) => ({ ...prevState, sortOrdererr: "" }));
                        }
                      }}
                      placeholder={t("sort_order_placeholder_txt")}
                    />
                    {errmessage.sortOrdererr && (
                      <div className="error-msg">
                        {errmessage.sortOrdererr}
                      </div>
                    )}
                  </div>
                  {/* Status Dropdown */}
                  <div className="input-field col-1">
                    <label className="full-width">{t("status_txt")}</label>
                    <select
                      className="col-4"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="active">{t("active_txt")}</option>
                      <option value="inactive">{t("inactive_txt")}</option>
                    </select>
                  </div>
                  <button title={t("submit_txt")} type="submit">{t("submit_txt")}</button> &nbsp;&nbsp;
                  <button title={t("cancel_txt")} onClick={(e) => cancelbtn(e)}>{t("cancel_txt")}</button>
                </form>
              )}
            </div>
          </div>
        </section>
        <Footer />
      </div>
      {visibleAlert === true && (
        <div className="custom-alert-pop" style={{ display: "block" }}>
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("file_size_less_than_8mb_txt")}</p>
                <div className="alert-buttons">
                  <a onClick={popupClose} className="popup-alert-btn button">
                    {t("ok_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
export default AddFreeproductspdf;
